import { render, staticRenderFns } from "./InvoiceMatchingForm.vue?vue&type=template&id=ec4875e0&"
import script from "./InvoiceMatchingForm.vue?vue&type=script&lang=ts&"
export * from "./InvoiceMatchingForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports